import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const InvestorsPage = ({ onRequestDemo, onRequestQuote }) => {
  return (
    <div className="min-h-screen bg-white">
      <SEO title="Investors — ctrl.aero" description="Investor relations, financials, and corporate information for CTRL Systems." />
      <Header onRequestDemo={onRequestDemo} onRequestQuote={onRequestQuote} />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800">
        <div className="absolute inset-0 opacity-20">
          <img 
            src="/images/img_0235.jpeg"
            alt="Aviation"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            Investor Relations
          </h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Building the future of aviation maintenance technology
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-3xl p-12 border border-blue-100">
            <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-[#1e2d3b] mb-4">
              Coming Soon
            </h2>
            <p className="text-lg text-slate-700 leading-relaxed">
              Our investor relations page is currently under development. For investment inquiries, please contact us directly.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default InvestorsPage;
